export default {"src":"/_next/static/media/tab-bell.bc4104c7.svg","height":40,"width":41};